import axios from "axios";

const BASE = process.env.REACT_APP_BACKEND_URL;
export const API = `${BASE}/api`;

export const api = axios.create({ baseURL: API });

export const fetchCiphers = () => api.get("/ciphers").then((r) => r.data.ciphers);
export const calculatePhrase = (text) => api.post("/calculate", { text }).then((r) => r.data);
export const searchByNumber = (value, ciphers) =>
  api.get("/search/number", { params: { value, ciphers, limit: 300 } }).then((r) => r.data);
export const listPhrases = (params = {}) => api.get("/phrases", { params }).then((r) => r.data);
export const createPhrase = (body) => api.post("/phrases", body).then((r) => r.data);
export const deletePhrase = (id) => api.delete(`/phrases/${id}`).then((r) => r.data);
export const dateNumerology = (dateStr) => api.post("/date/numerology", { date: dateStr }).then((r) => r.data);
export const dateDuration = (start, end) => api.post("/date/duration", { start, end }).then((r) => r.data);
export const fetchStats = () => api.get("/stats").then((r) => r.data);
export const parseJournal = (text) => api.post("/journal/parse", { text }).then((r) => r.data);
export const bulkImport = (phrases, default_tags = []) =>
  api.post("/import/bulk", { phrases, default_tags }).then((r) => r.data);
export const fetchPhraseAnalysis = (id) =>
  api.get(`/phrases/${id}/analysis`).then((r) => r.data);
export const fetchAnagrams = (text) =>
  api.get("/anagrams", { params: { text, limit: 200 } }).then((r) => r.data);

// ===== App downloads =====
export const apkInfo = () => api.get("/download/apk/info").then((r) => r.data);
export const APK_URL = `${API}/download/apk`;

// Fetches the offline single-file build and triggers a browser download.
export async function downloadOfflineFile() {
  const res = await fetch(`${API}/download/offline`);
  if (!res.ok) throw new Error("Download failed");
  const blob = await res.blob();
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  const stamp = new Date().toISOString().slice(0, 10).replace(/-/g, "");
  a.download = `gem-key-offline-${stamp}.html`;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}

// ===== Decode portfolio =====
const ADMIN_HEADER = "X-Admin-Token";
const adminTokenHeader = () => {
  const t = localStorage.getItem("gk_admin_token");
  return t ? { [ADMIN_HEADER]: t } : {};
};
export const listDecodes = (params = {}) => api.get("/decodes", { params }).then((r) => r.data);
export const getDecode = (id) => api.get(`/decodes/${id}`).then((r) => r.data);
export const createDecode = (body) =>
  api.post("/decodes", body, { headers: adminTokenHeader() }).then((r) => r.data);
export const updateDecode = (id, body) =>
  api.patch(`/decodes/${id}`, body, { headers: adminTokenHeader() }).then((r) => r.data);
export const deleteDecode = (id) =>
  api.delete(`/decodes/${id}`, { headers: adminTokenHeader() }).then((r) => r.data);
export const checkAdmin = (token) =>
  api.get("/decodes/admin/check", { headers: { [ADMIN_HEADER]: token } }).then((r) => r.data);
export const setAdminToken = (t) => localStorage.setItem("gk_admin_token", t);
export const getAdminToken = () => localStorage.getItem("gk_admin_token") || "";
export const clearAdminToken = () => localStorage.removeItem("gk_admin_token");

// ===== "Do Me A Decode" commission requests =====
export const createDecodeRequest = (body) =>
  api.post("/decode-requests", body).then((r) => r.data);
export const listDecodeRequests = () =>
  api.get("/decode-requests", { headers: adminTokenHeader() }).then((r) => r.data);
export const updateDecodeRequest = (id, status) =>
  api.patch(`/decode-requests/${id}`, { status }, { headers: adminTokenHeader() }).then((r) => r.data);
export const deleteDecodeRequest = (id) =>
  api.delete(`/decode-requests/${id}`, { headers: adminTokenHeader() }).then((r) => r.data);

// ===== Admin: force a phrase into dark / neutral / light =====
export const classifyPhrase = (id, category) =>
  api.patch(`/phrases/${id}/classify`, { category }, { headers: adminTokenHeader() }).then((r) => r.data);
